import * as React from "react";
import { Box, Button, InputAdornment, ButtonGroup } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FilterListIcon from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import {
  TextInput,
  NullableBooleanInput,
  useListContext,
  CheckboxGroupInput,
  useGetOne,
  SelectInput,
  useGetList,
  Loading,
  useStore,
  useGetIdentity,
  Datagrid,
  TextField,
  FunctionField,
  usePermissions,
} from "react-admin";
import { useForm, FormProvider, get } from "react-hook-form";
import SearchIcon from "@mui/icons-material/Search";
import InputDateField from "../../common/InputComponents/InputDateFieldOld";
import { JSONTree } from "react-json-tree";
import Grid from "@mui/material/Grid";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";
import NewApplicationModel from "../NewApplicationModel";
import { useController, Controller } from "react-hook-form";
import SwitchSubscriber from "../SwitchSubscriber";
import { useSelector } from "react-redux";
import CopyUrlModal from "../../Modal/CopyUrlModal";
import { getAtsStatusFilterLabel } from "../../../utils/atsApplicationStatus";

const style = {
  // position: 'absolute' as 'absolute',
  // top: '50%',
  // left: '50%',
  // transform: 'translate(-50%, -50%)',
  width: 450,
  // bgcolor: 'background.paper',
  // border: '2px solid #000',
  // boxShadow: 24,
  // p: 4,
};

export const AgentList = (props) => {
  //
  // debugger;
  const { Office } = props;
  const { data, isLoading, error } = useGetList("getagentlist", {
    filter: { url: Office?.URL, SubscriberID: Office?.SubscriberID },
  });

  //
  //
  return (
    <Box component="span">
      {isLoading && <p>Loading...</p>}
      {!isLoading && data && (
        <SelectInput
          sx={{ width: "100%" }}
          source="Agent"
          variant="outlined"
          choices={data?.map((item) => ({
            id: item.FullName,
            name: `${item.FullName}`,
          }))}
        />
      )}
    </Box>
  );
};

export const FloorPlan = (props) => {
  const { FloorPlan } = props;
  const { data, isLoading, error } = useGetList("getfloorlist", {
    filter: {
      PropertyID: FloorPlan?.ID,
      SubscriberID: FloorPlan?.SubscriberID,
    },
  });
  return (
    <Box component="span">
      {isLoading && <p>Loading...</p>}
      {!isLoading && data && (
        <SelectInput
          sx={{ width: "100%" }}
          source="Floor"
          variant="outlined"
          choices={data?.map((item) => ({
            id: item.FloorCode,
            name: `${item.FloorCode}`,
          }))}
        />
      )}
    </Box>
  );
};

export default function ActionSubscriberInbox(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const { id } = useParams();
  const { data: identity } = useGetIdentity();
  const {permissions} =usePermissions();
  const submitBtnRef = React.useRef<HTMLButtonElement>(null);
  const { data, isLoading, error } = useGetOne("getfilterforinbox", {
    id: id || identity?.subscriberid,
  });

  const { displayedFilters, filterValues, setFilters, hideFilter } =
    useListContext();
  // get user role from  global store
  const userRole =
    useSelector((state: any) => state?.users?.role) || identity?.userrole;

  // get application detail data
  const { data: applicationDetail, isLoading: isLoadingData } = useGetOne(
    "getnewapplicationdetail",
    {
      id: id || identity?.subscriberid,
    },
    { enabled: id || identity?.subscriberid ? true : false }
  );
  const form = useForm({
    defaultValues: filterValues,
  });

  // if (!displayedFilters.main) return null;
  const applyFilter = (values) => {
    if (Object.keys(values).length > 0) {
      const filter = {
        ...values,
        end_date: values.end_date
          ? moment(values.end_date).format("MM/DD/yyyy")
          : "",
        start_date: values.start_date
          ? moment(values.start_date).format("MM/DD/yyyy")
          : "",
      };
      setFilters(filter, displayedFilters);
      handleClose();
    }
  };
  const onSubmit = (values: any) => {
    applyFilter({
      ...values,
      app_invitation_type: filterValues?.app_invitation_type || 1,
    });
  };

  const [q, setQ] = React.useState<null | string>(filterValues?.q);

  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      form.setValue("q", q);
      if (q != null) {
        applyFilter({
          ...form.getValues(),
          app_invitation_type: filterValues?.app_invitation_type || 1,
        });
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [q]);

  React.useEffect(() => {
    if (filterValues.app_invitation_type) {
      form.reset(filterValues)
      if (!filterValues?.q) {
        setQ(filterValues?.q)
      }
    }
  }, [filterValues])

  React.useEffect(() => {
    if (Object.keys(filterValues).length === 0) {
      if (applicationDetail?.ApplicationType?.ATS) {
        setFilters({ app_invitation_type: "1" }, displayedFilters);
      } else if (applicationDetail?.ApplicationType?.DocUpload) {
        setFilters({ app_invitation_type: "2" }, displayedFilters);
      } else if (applicationDetail?.ApplicationType?.GuestCard) {
        setFilters({ app_invitation_type: "3" }, displayedFilters);
      }
    }
  }, [filterValues, applicationDetail]);

  const start_date = form.watch("start_date");

  const filteredApplicationsStatus = data?.Status?.map((item) => {
    const status = item.ApplicationStatus;
    return {
      ...item,
      ApplicationStatus: status,
      ApplicationStatusLabel: getAtsStatusFilterLabel(status),
    };
  }).filter((item) => {
    if (
      !filterValues.app_invitation_type ||
      filterValues.app_invitation_type == 1
    ) {
      return (
        item.ApplicationStatus === "Invited" ||
        item.ApplicationStatus === "Application In Progress" ||
        item.ApplicationStatus === "Submitted" ||
        item.ApplicationStatus === "Screening" ||
        item.ApplicationStatus === "Completed-Approved" ||
        item.ApplicationStatus === "CompletedConditionallyApproved" ||
        item.ApplicationStatus === "Completed-Conditionally Approved" ||
        item.ApplicationStatus === "Completed-Unacceptable"
      );
    } else if (filterValues.app_invitation_type == 2) {
      return (
        item.ApplicationStatus === "Invited" ||
        item.ApplicationStatus === "Application In Progress" ||
        item.ApplicationStatus === "Review Pending" ||
        item.ApplicationStatus === "Verified" ||
        item.ApplicationStatus === "Further Documentation Required" ||
        item.ApplicationStatus === "Unverifiable"
      );
    } else {
      return item;
    }
  });

  return (
    <>
    {/* <JSONTree data={permissions?.applicantrole}/> */}
      <div className="a-top-right-block">
        <div className="cus-search">
          <input
            type="text"
            name=""
            id=""
            value={q || ""}
            placeholder="Search"
            onChange={(e) => setQ(e?.target?.value)}
          />
        </div>
       
        <div className="group-btn">
        
            <button onClick={handleOpen} type="button" className="g-line-btn">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.11337 11C3.25111 10.6096 3.50653 10.2716 3.84444 10.0325C4.18235 9.79343 4.5861 9.66503 5.00004 9.66503C5.41398 9.66503 5.81773 9.79343 6.15564 10.0325C6.49355 10.2716 6.74897 10.6096 6.88671 11H13.6667V12.3333H6.88671C6.74897 12.7237 6.49355 13.0617 6.15564 13.3008C5.81773 13.5399 5.41398 13.6683 5.00004 13.6683C4.5861 13.6683 4.18235 13.5399 3.84444 13.3008C3.50653 13.0617 3.25111 12.7237 3.11337 12.3333H0.333374V11H3.11337ZM7.11337 6.33333C7.25111 5.94298 7.50653 5.60496 7.84444 5.36586C8.18235 5.12676 8.5861 4.99837 9.00004 4.99837C9.41398 4.99837 9.81773 5.12676 10.1556 5.36586C10.4935 5.60496 10.749 5.94298 10.8867 6.33333H13.6667V7.66667H10.8867C10.749 8.05702 10.4935 8.39504 10.1556 8.63414C9.81773 8.87324 9.41398 9.00163 9.00004 9.00163C8.5861 9.00163 8.18235 8.87324 7.84444 8.63414C7.50653 8.39504 7.25111 8.05702 7.11337 7.66667H0.333374V6.33333H7.11337ZM3.11337 1.66667C3.25111 1.27631 3.50653 0.938289 3.84444 0.699193C4.18235 0.460097 4.5861 0.331699 5.00004 0.331699C5.41398 0.331699 5.81773 0.460097 6.15564 0.699193C6.49355 0.938289 6.74897 1.27631 6.88671 1.66667H13.6667V3H6.88671C6.74897 3.39036 6.49355 3.72838 6.15564 3.96747C5.81773 4.20657 5.41398 4.33497 5.00004 4.33497C4.5861 4.33497 4.18235 4.20657 3.84444 3.96747C3.50653 3.72838 3.25111 3.39036 3.11337 3H0.333374V1.66667H3.11337ZM5.00004 3C5.17685 3 5.34642 2.92976 5.47145 2.80474C5.59647 2.67971 5.66671 2.51014 5.66671 2.33333C5.66671 2.15652 5.59647 1.98695 5.47145 1.86193C5.34642 1.7369 5.17685 1.66667 5.00004 1.66667C4.82323 1.66667 4.65366 1.7369 4.52864 1.86193C4.40361 1.98695 4.33337 2.15652 4.33337 2.33333C4.33337 2.51014 4.40361 2.67971 4.52864 2.80474C4.65366 2.92976 4.82323 3 5.00004 3ZM9.00004 7.66667C9.17685 7.66667 9.34642 7.59643 9.47145 7.4714C9.59647 7.34638 9.66671 7.17681 9.66671 7C9.66671 6.82319 9.59647 6.65362 9.47145 6.5286C9.34642 6.40357 9.17685 6.33333 9.00004 6.33333C8.82323 6.33333 8.65366 6.40357 8.52864 6.5286C8.40361 6.65362 8.33337 6.82319 8.33337 7C8.33337 7.17681 8.40361 7.34638 8.52864 7.4714C8.65366 7.59643 8.82323 7.66667 9.00004 7.66667ZM5.00004 12.3333C5.17685 12.3333 5.34642 12.2631 5.47145 12.1381C5.59647 12.013 5.66671 11.8435 5.66671 11.6667C5.66671 11.4899 5.59647 11.3203 5.47145 11.1953C5.34642 11.0702 5.17685 11 5.00004 11C4.82323 11 4.65366 11.0702 4.52864 11.1953C4.40361 11.3203 4.33337 11.4899 4.33337 11.6667C4.33337 11.8435 4.40361 12.013 4.52864 12.1381C4.65366 12.2631 4.82323 12.3333 5.00004 12.3333Z"
                  fill="#909090"
                />
              </svg>
            </button>
          
          {data?.CompanyType && <CopyUrlModal dataSubscriberInfo={data} />}
          {permissions?.applicantrole &&  <NewApplicationModel />}
        </div>
      </div>

      <Dialog
        className="filter-modal"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="dialog_title_filters">
          Filters
        </DialogTitle>
        <DialogContent className="dialog_content_filters">
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              {/* <DialogContentText id="alert-dialog-description"> */}
              <Box sx={style} component={"div"}>
                <Box
                  className="card-s-title"
                  display="flex"
                  flexDirection={"column"}
                  alignItems="flex-start"
                  mb={1}
                >
                  <h6>Date Range</h6>

                  <Box
                    className="date-label"
                    sx={{ width: "100%", paddingTop: 1 }}
                    alignItems={"center"}
                    display={"flex"}
                    component="span"
                    mr={2}
                  >
                    <span style={{ paddingRight: 2, paddingBottom: 10 }}>
                      <strong>From:</strong>
                    </span>
                    <InputDateField
                      source={"start_date"}
                      maxDate={new Date()}
                    />
                    <strong
                      style={{
                        paddingRight: 2,
                        paddingLeft: 2,
                        paddingBottom: 10,
                        fontSize: "14px",
                        color: "#303030",
                        fontWeight: "inherit",
                      }}
                    >
                      &nbsp;To&nbsp;
                    </strong>
                    <InputDateField source={"end_date"}  minDate={start_date ? moment(start_date).toDate() : undefined} />
                  </Box>
                  <hr className="w-100" />
                  {/* <div className='w-100' style={{ borderBottom: '2px solid lightgrey', paddingTop: '10px' }}></div> */}
                  <Box component="span" mt={2}>
                    <h6>Application Status</h6>
                  </Box>
                  <Box component="span" className="app-list">
                    <CheckboxGroupInput
                      className="app_list_checkbox"
                      sx={{ marginTop: 0 }}
                      row={false}
                      label=""
                      source="ApplicationStatus"
                      choices={filteredApplicationsStatus?.map((item) => {
                        return {
                          id: item.ApplicationStatus,
                          name: item.ApplicationStatusLabel || item.ApplicationStatus,
                        };
                      })}
                    />
                  </Box>
                  <hr className="w-100" />
                  {/* <div className='w-100' style={{ borderBottom: '2px solid lightgrey', paddingTop: '10px' }}></div> */}

                  {data?.Offices?.length > 0 && (
                    <Box sx={{ width: "100%" }} component="span" mt={1}>
                      <h6>For {data?.CompanyType}</h6>
                      <Grid
                        mt={1}
                        px={2}
                        container
                        spacing={2}
                        className="grid_padding"
                      >
                        <Grid item xs={6} px={1}>
                          <SelectInput
                            sx={{ width: "100%" }}
                            source="Office"
                            variant="outlined"
                            choices={data?.Offices.map((item) => {
                              return {
                                id: item?.OfficeName,
                                name: item.OfficeName,
                              };
                            })}
                          />
                        </Grid>
                        <Grid item xs={6} px={1}>
                          {form.watch().Office && (
                            <AgentList
                              Office={
                                data?.Offices.filter(
                                  (item) =>
                                    item.OfficeName == form.watch().Office
                                )[0]
                              }
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                  {data?.Properties?.length > 0 && (
                    <Box sx={{ width: "100%" }} component="span" mt={1}>
                      <h6>For {data?.CompanyType}</h6>
                      <Grid
                        mt={1}
                        px={2}
                        container
                        spacing={2}
                        className="grid_padding"
                      >
                        <Grid item xs={6} px={1}>
                          <SelectInput
                            sx={{ width: "100%" }}
                            source="Property"
                            variant="outlined"
                            choices={data?.Properties.map((item) => {
                              return {
                                id: item?.PropertyName,
                                name: item.PropertyName,
                              };
                            })}
                          />
                        </Grid>
                        <Grid item xs={6} px={1}>
                          {form.watch().Property && (
                            <FloorPlan
                              FloorPlan={
                                data?.Properties.filter(
                                  (item) =>
                                    item.PropertyName == form.watch().Property
                                )[0]
                              }
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                </Box>
                <Box display={"flex"} justifyContent={"end"}>
                  <Button
                    ref={submitBtnRef}
                    sx={{ mx: 1 }}
                    variant="contained"
                    type="submit"
                    autoFocus
                    className="blue-btn"
                  >
                    Apply Filter
                  </Button>
                  <Button
                    sx={{ mx: 1 }}
                    onClick={handleClose}
                    variant="outlined"
                    color="secondary"
                    type="button"
                  >
                    Close
                  </Button>
                </Box>
              </Box>
              {/* </DialogContentText> */}
            </form>
          </FormProvider>
        </DialogContent>
      </Dialog>
    </>
  );
}
